import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const videoStreamUrl = (id, variant = 'original') => `${API}/videos/${id}/stream${variant === 'overlay' ? '?variant=overlay' : ''}`;
export const videoThumbUrl = (id) => `${API}/videos/${id}/thumbnail`;
export const moduleStreamUrl = (id) => `${API}/modules/${id}/stream`;

export const ACCENT = '#22C55E';
export const ACCENT_HOVER = '#4ADE80';
// legacy alias kept for compatibility
export const NEON = ACCENT;

export const scoreColor = (score) => {
  if (score == null) return 'text-white/50';
  if (score >= 80) return 'text-[#22C55E]';
  if (score >= 60) return 'text-[#9BD770]';
  if (score >= 40) return 'text-[#E9C46A]';
  return 'text-[#E76F7B]';
};

export const scoreBg = (score) => {
  if (score == null) return 'bg-white/10 text-white/50 border-white/10';
  if (score >= 80) return 'bg-[rgba(34,197,94,0.14)] text-[#22C55E] border-[rgba(34,197,94,0.3)]';
  if (score >= 60) return 'bg-[rgba(155,215,112,0.12)] text-[#9BD770] border-[rgba(155,215,112,0.3)]';
  if (score >= 40) return 'bg-[rgba(233,196,106,0.12)] text-[#E9C46A] border-[rgba(233,196,106,0.3)]';
  return 'bg-[rgba(231,111,123,0.12)] text-[#E76F7B] border-[rgba(231,111,123,0.3)]';
};

export const barColor = (score) => {
  if (score == null) return '#6B7280';
  if (score >= 80) return '#22C55E';
  if (score >= 60) return '#9BD770';
  if (score >= 40) return '#E9C46A';
  return '#E76F7B';
};

export const formatDate = (iso, lang) => {
  try {
    return new Date(iso).toLocaleDateString(lang === 'it' ? 'it-IT' : 'en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch (err) {
    console.debug('formatDate failed for value:', iso, err?.message);
    return '';
  }
};

export const formatPrice = (cents, currency = 'eur') => {
  if (!cents) return null;
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency: currency.toUpperCase() }).format(cents / 100);
};

export const roleBadgeClass = (role) => {
  if (role === 'admin') return 'bg-[rgba(231,111,123,0.14)] text-[#E76F7B] border-[rgba(231,111,123,0.3)]';
  if (role === 'coach') return 'bg-white/[0.12] text-white border-white/20';
  return 'bg-white/[0.07] text-white/60 border-white/10';
};
